import axios from 'axios'
import router from '../router'
// import store from '../store'

// 创建一个axios实例
const axiosService = axios.create({
    baseURL: 'https://www.citygroup.com.cn:8443/exlandlord',
    // baseURL: 'http://172.16.64.58:8087',
    timeout: 5000 //设置超时间为5s
})

// request拦截器 ==> 对请求参数进行处理
axiosService.interceptors.request.use(
    config => {
        // 可以在发送请求之前做些事情
        // 比如请求参数的处理、在headers中携带token等等
        // console.log(config)
        // config.headers['Authori-zation'] = localStorage.getItem('LOGIN_STATUS_TOKEN')
        // user:normal:410d53466f22471ca31ba441d25da748
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
        // console.log('8888')
        // store.state.isShow = true; // 显示加载loading
        // if(router.currentRoute.path === '/openAccount') {
        //     config.withCredentials = true // 提交验证码携带cookie提交
        // }
        return config
    },error => {
        // 处理请求错误
        Promise.reject(error)
    }
)

// respone拦截器 ==> 对响应做处理
axiosService.interceptors.response.use(
    response => {
        const res = response.data

        // console.log(res)
        if (res.code == 446) {
            router.push('/cover')
        }
        // 如果自定义的返回码不等于200, 就返回一个错误
        // if (res.code != 200) {
        //     return Promise.reject(new Error(res.message || "Error"))
        // } else {
        //     return res
        // }
        return res
    },error => {
        // store.state.isShow = false // 关闭加载loading
        // 判断error的status代码，并将对应的信息告知用户
        // console.log('打印text')
        // let text = ""
        // let err = JSON.parse(JSON.stringify(error))
        // if (err.response.status) {
        //     switch (error.response.status) {
        //         case 400:
        //             text = "请求错误(400)，请重新申请"
        //             break;
        //         case 401:
        //             text = '登录错误(401)，请重新登录'
        //             return this.$router.replace("/login")
        //     }
        // }
        return Promise.reject(error)
    }
)

// 将写好的axios实例暴露出去
export default axiosService